/** Translation (i18n) keys for audit log item field names */
export const AuditLogTranslationKeys: Record<string, string> = {
  // Shared fields
  ServiceMeasurementUnit: "service",
  Partner: "partner",
  Status: "status",

  // Work order fields
  WorkOrderId: "id",
  PartnerName: "partner",
  CreationDate: "creationDate",
  PlannedDate: "plannedDate",
  CreatorUserName: "creator",
  MainContractSapId: "mainContract",
  ContractPrice: "contractPrice",
  ContractDistance: "contractDistance",
  BusinessUnitName: "businessUnit",
  InternalNote: "internalNote",
  Category: "category",
  RelatedContracts: "relatedContracts",
  Attachment: "Attachment",

  // Work Order Item fields
  ServiceQuantityPlanned: "quantityOrdered",
  ServiceQuantityPerformed: "quantityPerformed",
  ServiceQuantityCorrected: "quantityCorrected",
  IsUncompleted: "uncompleted",
  IsCorrected: "IsCorrected",
  IsDisputed: "disputed",
  Comment: "comment",

  // User fields
  Id: "id",
  Email: "email",
  UserName: "userName",
  Name: "name",
  Surname: "surname",
  BusinessUnits: "businessUnits",
  Roles: "roles",
  Password: "password",

  // Service price fields
  ValidFrom: "validFrom",
  ValidTo: "validTo",
  BusinessUnit: "businessUnit",
  PricePerUnit: "pricePerUnit",

  // Business unit fields
  BusinessUnitId: "id",
  SapCode: "sapId",
  Emails: "emails",

  // Specification fields
  SpecificationId: "id",
  SpecificationNumber: "specificationNumber",
  OrderNumber: "orderNumber",
  FromDate: "billingPeriodFrom",
  ToDate: "billingPeriodTo",
  WorkOrders: "workOrderListTitle",
  IsDeleted: "isDeleted",

  // Contract fields
  Address: "mainAddress",
  ContractId: "id",
  SapId: "sapId",
  Price: "price",
  Distance: "distance",
  BuyerName: "buyerName"
};
